import script from "/home/danlo/Documentos/Projetos/E/ee.usp.br/frontend/src/assets/js/layout/KMenu/KMenuItem.vue?type=script"
export * from "/home/danlo/Documentos/Projetos/E/ee.usp.br/frontend/src/assets/js/layout/KMenu/KMenuItem.vue?type=script"

import "/home/danlo/Documentos/Projetos/E/ee.usp.br/frontend/src/assets/js/layout/KMenu/KMenuItem.vue?type=style&index=0"
export default script